import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AddressInput, {
  ADDRESS_ROW_TYPES,
  isScrollAddressRowType,
} from 'modules/core/components/AddressInput'
import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import InlineTooltip from 'modules/core/components/InlineTooltip'
import DayPicker from 'modules/core/components/Inputs/DayPicker'
import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'
import type Employee from 'modules/employees/store/models/Employee'

import type { ScrollRowType } from '../types'

interface Props {
  employee: Employee
  readonly: boolean
  errors?: Record<string, string[] | Record<string, string>> | undefined | null
  scrollTo?: ScrollRowType | null | undefined
}

const ExtraInformation = ({ errors = null, employee, scrollTo = null, readonly }: Props) => {
  const {
    extraInformationForm,
    onSubmit: onSubmitExtraInformationForm,
    disableSectionSaveButtons,
  } = useEmployeePersonalProvider()

  React.useEffect(() => {
    errors && extraInformationForm.setErrors(errors)
  }, [extraInformationForm, errors])

  const scrollToRow = (type: Props['scrollTo']): boolean => scrollTo === type

  const scrollToAddress =
    scrollTo && isScrollAddressRowType(scrollTo) ? ADDRESS_ROW_TYPES[scrollTo] : null

  const onSubmit = () => {
    onSubmitExtraInformationForm([FormTypes.EXTRA_INFORMATION])
  }

  return (
    <InlineTooltip>
      <FormComponent>
        <FormRow>
          <AddressInput
            scrollTo={scrollToAddress}
            form={extraInformationForm}
            readonly={readonly}
          />
        </FormRow>
        <FormRow scrollToRow={scrollToRow('identifier')}>
          <Text
            label={i18n.t('employee_form.identifier')}
            field={extraInformationForm.get('identifier')}
            readonly={readonly}
          />
        </FormRow>
        <FormRow scrollToRow={scrollToRow('no_resident_end_date')}>
          <DayPicker
            label={i18n.t('employee_form.tax_residence.no_resident_end_date')}
            field={extraInformationForm.get('no_resident_end_date')}
            readonly={readonly}
          />
        </FormRow>
        {!disableSectionSaveButtons && extraInformationForm.isDirty && (
          <FormRow footer>
            <Button onClick={onSubmit}>{i18n.t('common.submit')}</Button>
          </FormRow>
        )}
      </FormComponent>
    </InlineTooltip>
  )
}

export default observer(ExtraInformation)
